<template>
    <div class="login" :style="loginConfig.backgroundImg ? 'background: url(' + loginConfig.backgroundImg + ');background-size: 100% 100%' : ''">
       <div class="top">
           <div class="external-link">
               <a v-for="(item, index) in this.externalLink" :key="index" :href="item.url" target="_blank" class="external-link-btn">{{ item.label }}</a>
           </div>
       </div>
        <div class="con">
            <div class="header"><img :src="pageConfig.icon ? pageConfig.icon : require('../assets/img/logo.png')" alt=""><span> {{pageConfig.name}}</span></div>
            <div style="width:420px;height:518px">
                <el-card v-show="show && !reset" shadow="always">
                    <div slot="header" class="clearfix">
                        <span class="cardTitle">{{ loginConfig.title }}</span>
                        <el-button type="text" size="mediue" @click="show=!show">{{ loginTextConfig.backendLogin }}<i class="el-icon-arrow-right"></i></el-button>
                    </div>
                    <el-form :model="stuForm" :rules="stuRules" ref="stuForm">
                        <el-form-item :label="loginTextConfig.examinee.username" prop="username">
                            <el-input v-model.trim="stuForm.username" size="mediue" maxlength="50" clearable :placeholder="loginTextConfig.examinee.usernameTip"></el-input>
                        </el-form-item>
                        <el-form-item :label="loginConfig.accountLabel" prop="number">
                            <el-input v-model.trim="stuForm.number" size="mediue" maxlength="40" clearable :placeholder="loginTextConfig.examinee.admissionTip.signMix(loginConfig.accountLabel)"></el-input>
                        </el-form-item>
                        <el-form-item :label="loginTextConfig.examinee.password" prop="password">
                            <el-input type="password" v-model.trim="stuForm.password" size="mediue" maxlength="6" show-word-limit clearable show-password  :placeholder="loginTextConfig.examinee.passwordTip.signMix(loginConfig.accountLabel)"></el-input>
                        </el-form-item>
                        <el-form-item label=" " class="submit">
                            <el-button type="primary" size="mediue" @click="submitStuForm('stuForm')" style="white-space: pre">{{ loginTextConfig.button }}</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-card v-show="!show && !reset" shadow="always">
                    <div slot="header" class="clearfix">
                        <span class="cardTitle">{{ loginTextConfig.backendLogin }}</span>
                        <el-button type="text" size="mediue" @click="show=!show">{{ loginConfig.title }}<i class="el-icon-arrow-right"></i></el-button>
                    </div>
                    <el-form :model="form" :rules="rules" ref="form">
                        <el-form-item :label="loginTextConfig.admin.username" prop="username">
                            <el-input v-model.trim="form.username" size="mediue" clearable :placeholder="loginTextConfig.admin.usernameTip"></el-input>
                        </el-form-item>
                        <el-form-item :label="loginTextConfig.admin.password" prop="password">
                            <el-input type="password" v-model.trim="form.password" size="mediue" maxlength="20" show-word-limit clearable show-password :placeholder="loginTextConfig.admin.passwordTip"></el-input>
                        </el-form-item>
                        <el-row type="flex" justify="space-between">
                            <el-checkbox v-model="checked" style="line-height:40px">{{ loginTextConfig.admin.remember }}</el-checkbox>
                            <el-button type="text" size="mediue" @click="show=false,reset=true" style="color:#666">{{ loginTextConfig.admin.forget }}</el-button>
                        </el-row>
                        <el-form-item label=" " class="submit">
                            <el-button type="primary" size="mediue" @click="submitForm('form')" style="white-space: pre">{{ loginTextConfig.button }}</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
                <el-card v-show="reset" shadow="always">
                    <div slot="header" class="clearfix">
                        <span class="cardTitle">{{ loginTextConfig.reset.title }}</span>
                        <el-button type="text" size="mediue" @click="reset=false,show=false">{{ loginTextConfig.reset.back }}<i class="el-icon-arrow-right"></i></el-button>
                    </div>
                    <el-form :model="resetForm" :rules="restRules" ref="resetForm">
                        <el-form-item :label="loginTextConfig.reset.username" prop="number">
                            <el-input v-model.trim="resetForm.number" @blur="numberBlur" size="mediue" clearable :placeholder="loginTextConfig.reset.usernameTip"></el-input>
                        </el-form-item>
                        <el-form-item :label="loginTextConfig.reset.password" prop="password">
                            <el-input type="password" size="mediue" v-model.trim="resetForm.password" clearable show-password :placeholder="loginTextConfig.reset.passwordTip"></el-input>
                        </el-form-item>
                        <el-form-item :label="loginTextConfig.reset.code" prop="code" class="verificationCode">
                            <el-row :gutter="2">
                                <el-col :span="16"><el-input v-model.number="resetForm.code" size="mediue" :disabled="codeDisable" clearable :placeholder="loginTextConfig.reset.codeTip"></el-input></el-col>
                                <el-col :span="8"><el-button type="primary" size="mediue" plain :disabled="wait" @click="codeDisable = false,wait = true">{{ loginTextConfig.reset.getCode }}</el-button></el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item label=" " class="submit">
                            <el-button type="primary" size="mediue" @click="submitResetForm('resetForm')">{{ loginTextConfig.reset.button }}</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div>
        </div>
        <waves-svg v-if="loginConfig.backgroundWaves"></waves-svg>
        <p class="footer">{{ $store.state.global.textConfig.copyRight }}</p>
    </div>
</template>

<script>
import wavesSvg from '@/components/waves'
export default {
    components: { wavesSvg },
    data() {
        let $this = this
        return {
            pageConfig: {
                name: '',                      // 名称，原：1+X证书考试系统
                icon: '',                      // 图标（为空则按照原设计）
            },
            loginConfig: {
                title: '',                    // 登录页标题，原：考生登录
                accountLabel: '',             // 账号名称字段，原：准考证号
                backgroundImg: '',            // 背景图（为空则按照原设计）
                backgroundWaves: true,        // 背景波浪是否显示
            },
            externalLink: [],
            show: true,
            reset: false,
            wait: true,
            stuForm:{
                username: '',
                number: '',
                password: ''
            },
            form:{
                username: '',
                password: ''
            },
            resetForm:{
                number: '',
                password: '',
                code: ''
            },
            stuRules: {
                username: [
                    { required: true, message: this.$store.state.global.textConfig.login.examinee.usernameRule, trigger: 'change' },
                ],
                number: [
                    // {  message: '请输入', trigger: 'change' },
                    {required: true,
                        validator: function(rule, value, callback) {
                            if (value) {
                                if (/^[a-zA-Z0-9]+$/g.test(value) == false) {
                                    callback(new Error("仅支持输入大小写字母和数字"));
                                } else {
                                    callback();
                                }
                            } else {
                                callback($this.$store.state.global.textConfig.login.examinee.admissionRule.signMix($this.loginConfig.accountLabel))
                            }
                        },
                        trigger: "change"
                    }
                ],
                password: [
                    { required: true, message: this.$store.state.global.textConfig.login.examinee.passwordRule, trigger: 'change' },
                    {
                        validator: function(rule, value, callback) {
                            if (/^[a-zA-Z0-9]+$/g.test(value) == false && value) {
                                callback(new Error("仅支持输入大小写字母和数字"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
            },
            rules:{
                username: [
                    { required: true, message: this.$store.state.global.textConfig.login.admin.usernameRule, trigger: 'change' },
                ],
                password: [
                    { required: true, message: this.$store.state.global.textConfig.login.admin.passwordRule, trigger: 'change' },
                    {
                        validator: function(rule, value, callback) {
                            if (/([^\u4E00-\u9FA5]{8,20})+$/g.test(value) == false && value) {
                                let passwrodStr = $this.$store.state.global.textConfig.login.admin.password
                                callback(new Error("不允许输入中文，且{0}为8-20位".signMix(passwrodStr)));
                            }
                            else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ]
            },
            restRules: {
                number: [
                    { required: true, message: this.$store.state.global.textConfig.login.reset.usernameRule, trigger: 'change' },
                    {
                        validator: function(rule, value, callback) {
                            if ((/^1[3|4|5|6|7|8|9]\d{9}$/g.test(value) == false && /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/g.test(value) == false) && value) {
                                callback(new Error($this.$store.state.global.textConfig.login.reset.usernameRule2));
                            }
                            else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
                password: [
                    { required: true, message: this.$store.state.global.textConfig.login.reset.passwordRule, trigger: 'change' },
                    {
                        validator: function(rule, value, callback) {
                            if (/([^\u4E00-\u9FA5]{8,20})+$/g.test(value) == false && value) {
                                let passwrodStr = $this.$store.state.global.textConfig.login.admin.password
                                callback(new Error("不允许输入中文，且{0}为8-20位".signMix(passwrodStr)));
                            }
                            else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
                code: [
                    { required: true, message: this.$store.state.global.textConfig.login.reset.codeRule, trigger: 'change' },
                ]

            },
            checked: false,
            codeDisable: true,
        }
    },
    computed: {
        loginTextConfig() {
            return this.$store.state.global.textConfig.login
        }
    },
    created() {
        let loginType = this.$route.query.login
        if (loginType === 'fail') {
            this.$message.error('用户名或密码错误')
        }
        let config = this.$store.state.projectConfig
        this.pageConfig = config.page
        this.loginConfig = config.login
        this.externalLink = config.externalLink
        window.addEventListener('keydown', this.submit, true)//开启监听键盘按下事件
        this.$store.state.global.isConfirmInfo = false
    },
    mounted() {
        var loginVal = JSON.parse(localStorage.getItem("loginData"));
        if(loginVal) {
            this.form.username = loginVal.username
            this.form.password = loginVal.password
            this.checked = true
        }
    },
    destroyed() {
        window.removeEventListener("keydown", this.submit, true);
    },
    methods: {
        numberBlur() {
            if (this.resetForm.number.length>0) {
                this.$refs['resetForm'].validateField(['number'],(valid)=>{
                    if(valid){
                        this.wait = true
                    }else {
                        this.wait = false
                    }
                })
            }else {
                this.wait = true
            }
        },
        submitStuForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    function hashCode(str){
                        let hash = 0;
                        if (str.length == 0) return hash;
                        for (let i = 0; i < str.length; i++) {
                            let char = str.charCodeAt(i);
                            hash = ((hash<<5)-hash)+char;
                            hash = hash & hash; // Convert to 32bit integer
                        }
                        return hash;
                    }
                    localStorage.setItem("1+XUserIdentity", 'Candidate');
                    let username = hashCode(this.stuForm.username) + this.stuForm.number
                    window.location.href = `/login?username=${username}&password=${this.stuForm.password}`
                } else {
                    return false;
                }
            });
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.checked) {
                        localStorage.setItem("loginData", JSON.stringify(this.$refs[formName].model));
                    } else {
                        localStorage.removeItem("loginData");
                    }
                    localStorage.setItem("1+XUserIdentity", this.form.username);
                    window.location.href = `/login?username=${this.form.username}&password=${this.form.password}`
                    // this.$store.dispatch("userLogin", this.form).then(res => {
                    //     if (res.status == 200) {
                    //         this.$store.dispatch("getPermissionsList", res.data.permissions)
                    //         if (this.checked) {
                    //             localStorage.setItem("loginData", JSON.stringify(this.$refs[formName].model));
                    //         }else {
                    //             localStorage.removeItem("loginData");
                    //         }
                    //         localStorage.setItem("1+XUserIdentity", res.data.username);
                    //         localStorage.setItem("1+XAdministration", res.data.userAlias);
                    //         localStorage.setItem('1+XPermissionsList',JSON.stringify(res.data.permissions))
                    //         this.$message({
                    //             type: 'success',
                    //             message: this.loginTextConfig.admin.success
                    //         });
                    //         if (res.data.permissions.indexOf('menu:arrangement:subject') !== -1) {
                    //             console.log(res.data.permissions.indexOf('menu:arrangement:subject'),res.data.permissions);
                    //             this.$router.push('/subject')
                    //         } else if (res.data.permissions.indexOf('menu:review') !== -1) {
                    //             this.$router.push('/marking')
                    //         } else {
                    //             this.$router.push('/')
                    //         }
                    //
                    //     }
                    // })
                } else {
                    return false;
                }
            });
        },
        submitResetForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$message({
                        type: 'success',
                        message: this.loginTextConfig.reset.success
                    });
                    this.reset = false
                    this.show = false
                } else {
                    return false;
                }
            });
        },
        submit(e) {
            if (e.keyCode === 13) {
                if (this.reset) {
                    this.submitResetForm('resetForm')
                }else {
                    if (this.show) {
                        this.submitStuForm('stuForm')
                    }else {
                        this.submitForm('form')
                    }
                }
            }
        },
    }
}
</script>

<style scoped>
    .login {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        background: url("../assets/img/bg.png");
    }
    .bg2 {
        height: 336px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    .external-link {
        position: fixed;
        padding: 8px;
        z-index: 99;
    }
    .external-link a {
        margin: 8px 8px 0 8px;
    }
    .external-link-btn {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        -webkit-appearance: none;
        text-align: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        -webkit-transition: .1s;
        transition: .1s;
        font-weight: 500;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
        color: #333;
        border-color: #EBF2FB;
        background: #EBF2FB;
    }
    .external-link-btn:hover {
        background: #338de5;
        border-color: #338de5;
        color: #fff;
    }
    .con {
        width: 100%;
        height: calc(100% - 40px);
        min-height: 748px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
        z-index: 2;
    }
    .header{
        text-align: center;
        font-size: 29px;
        font-weight: 600;
        letter-spacing: 2px;
        color: #0070de;
        margin-bottom: 60px;
    }
    .header img {
        width: 50px;
        height: 50px;
        margin-top: -7px;
    }
    .footer {
        background: #0070de;
        color: #fff;
        line-height: 40px;
        text-align: center;
        font-size: 12px;
        width: 100%;
        position: relative;
        z-index: 2;
    }
    .el-card {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 2;
        box-shadow: 0 2px 15px 0 rgb(0 0 0 / 3%) !important;
        border: 0 !important;
        border-radius: 8px !important;
    }
    .el-card .clearfix {
        text-align: center;
        font-weight: 600;
        font-size: 21px;
        color: #0070de;
        margin-top: 40px;
    }
    .el-card .clearfix button {
        position: absolute;
        right: 40px;
        top: 63px;
        color: #666;
    }
    .el-card >>> .el-card__header {
        padding: 24px 20px;
        border-bottom: none;
    }
    .el-card >>> .el-card__body {
        padding: 15px 40px;
    }
    .submit {
        position: absolute;
        bottom: 45px;
        width: calc(100% - 80px);
    }
    .submit .el-button {
        box-shadow: 0px 3px 10px 0 rgb(0 112 222 / 44%);
        width: 100%;
    }
    .verificationCode >>> .el-form-item__label {
        width: 100%;
        text-align: left;
    }
</style>
